import { useCallback, useState } from 'react';

import useFetch from 'hooks/useFetch';
import useRetry from 'hooks/useRetry';

import useTranslation from './hooks/useTranslation';

import { CHEMICAL_DB_API_HOST, JSON_HEADERS, MIX_ORDER_API } from './constants';
import type { FetchMixOrderAdvisory, MixOrderResponse } from './types';

const useMixOrderAdvisory = () => {
    const [isLoading, setIsLoading] = useState(false);
    const { authenticatedPost } = useFetch({
        apiHost: CHEMICAL_DB_API_HOST,
        headers: JSON_HEADERS
    });
    const { withRetry } = useRetry();
    const { CONNECTION_ERROR } = useTranslation();

    const fetch: FetchMixOrderAdvisory = useCallback(
        async ({ request }) => {
            try {
                setIsLoading(true);

                return await withRetry(
                    () =>
                        authenticatedPost<MixOrderResponse>(MIX_ORDER_API, JSON.stringify(request)),
                    CONNECTION_ERROR,
                    () => fetch({ request })
                );
            } finally {
                setIsLoading(false);
            }
        },
        [authenticatedPost, withRetry, CONNECTION_ERROR]
    );

    return { fetch, isLoading };
};

export default useMixOrderAdvisory;
